import script from "./DashboardPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardPage.vue?vue&type=script&setup=true&lang=js"

import "./DashboardPage.vue?vue&type=style&index=0&id=5d817490&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d817490"]])

export default __exports__